<h1>Add This Share Tool</h1>

<label>
  url
  <input type="text" [(ngModel)]="url">
</label>
<label>
  title
  <textarea [(ngModel)]="title"></textarea>
</label>
<label>
  description
  <input type="text" [(ngModel)]="description">
</label>
<label>
  media
  <input type="text" [(ngModel)]="media">
</label>
<!-- <label>
  email_template
  <input type="text" [(ngModel)]="addthis_share.email_template">
</label>
<label>
  email_vars
  <textarea [(ngModel)]="parse.email_vars"></textarea>
</label>
<label>
  passthrough
  <textarea [(ngModel)]="parse.passthrough"></textarea>
</label>
<label>
  url_transforms
  <textarea [(ngModel)]="parse.url_transforms"></textarea>
</label> -->

<button (click)="load()">Load</button>

<ng-container *ngIf="loaded">
  <tyt-social-buttons
    [url]="url"
    [title]="title"
    [description]="description"
    [media]="media"
    ></tyt-social-buttons>
</ng-container>